import { registerLocaleData } from '@angular/common';
import { inject, Injector, LOCALE_ID } from '@angular/core';
import { from, of, switchMap } from 'rxjs';

import { LoggerService } from '@accesso/cc-std-lib';

import { MerchantStore } from '../../feature/merchant/merchant.store';
import { onMerchantInitialized } from './initializer.utils';

export const provideLocaleId = () => {
	return {
		provide: LOCALE_ID,
		useFactory: (merchant: InstanceType<typeof MerchantStore>) => merchant.store()?.language(),
		deps: [MerchantStore],
	};
};

export const localizationDataInitializer = () => {
	const injector = inject(Injector);

	return onMerchantInitialized()?.pipe(
		switchMap(() => {
			const merchant = injector.get(MerchantStore);
			const logger = injector.get(LoggerService);

			const lang = merchant.store()?.language();
			if (!lang) throw new Error('Store language not found');
			if (['en', 'en-US'].includes(lang)) return of(null);

			return from(
				import(`../../../../node_modules/@angular/common/locales/${lang}.js`)
					.then((mod) => registerLocaleData(mod.default, lang))
					.catch((err) => logger.error(`Error loading locale data for ${lang}: ${err}`))
			);
		})
	);
};
